import {
  Api as ApiIcon,
  Assessment as AssessmentIcon,
  Build as BuildIcon,
  PauseCircleOutlined as PauseCircleOutlinedIcon,
  TableView as TableViewIcon,
} from "@mui/icons-material";
import { FC, MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import {
  capitalize,
  LeftActiveAdminPageEnum,
  RoutesAdmin,
  settingsDrawerOpenStateAtom,
  useLeftbarAdminActivePaths,
} from "@ryde/shared";

import {
  AdminNavIconWrapper,
  LeftBarButton,
  LeftBarNavigationStyled,
  SideBarLink,
} from "./parts";

export const LeftBarNavigationAdmin: FC = () => {
  const { isActive } = useLeftbarAdminActivePaths();

  const setSettingDrawerOpenState = useSetRecoilState(
    settingsDrawerOpenStateAtom,
  );

  const rightBarToggleEvent: MouseEventHandler<HTMLElement> = e => {
    e.preventDefault();
    setSettingDrawerOpenState(true);
  };

  const { t } = useTranslation();
  return (
    <LeftBarNavigationStyled className="nav_ul">
      <SideBarLink
        to={RoutesAdmin.AUDIT_LOGS}
        tooltip={capitalize(t("auditLog.plural"))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.AuditLogs)}
        >
          <SVG_MUI.History2AdminSVG width={22} height={22} />
        </AdminNavIconWrapper>
      </SideBarLink>
      <SideBarLink
        to={RoutesAdmin.PROVIDER_LOGS}
        tooltip={capitalize(t("providerLog.plural"))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.ProviderLogs)}
        >
          <ApiIcon />
        </AdminNavIconWrapper>
      </SideBarLink>
      <SideBarLink
        to={RoutesAdmin.ETL_JOB_LOGS}
        tooltip={capitalize(t("etlJobLog.plural"))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.EtlJobLogs)}
        >
          <BuildIcon />
        </AdminNavIconWrapper>
      </SideBarLink>
      <SideBarLink
        to={RoutesAdmin.SUPPLIER_QUARANTINES}
        tooltip={capitalize(t("supplierQuarantine.plural"))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.SupplierQuarantines)}
        >
          <PauseCircleOutlinedIcon />
        </AdminNavIconWrapper>
      </SideBarLink>
      <SideBarLink
        to={RoutesAdmin.PROCESSES}
        tooltip={capitalize(t("process.processDrawerTitle"))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.Processes)}
        >
          <TableViewIcon />
        </AdminNavIconWrapper>
      </SideBarLink>
      <SideBarLink
        to={RoutesAdmin.MESSAGING_LOGS}
        tooltip={capitalize(t("messagingLog.plural"))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.MessagingLogs)}
        >
          <SVG_MUI.MessageLines3AdminSVG width={22} height={22} />
        </AdminNavIconWrapper>
      </SideBarLink>
      <SideBarLink
        to={RoutesAdmin.REPORT_MANAGEMENT}
        tooltip={capitalize(t("report.REPORT_MANAGEMENT_TITLE"))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.ReportManagement)}
        >
          <AssessmentIcon />
        </AdminNavIconWrapper>
      </SideBarLink>
      <LeftBarButton
        onMenuItemClick={rightBarToggleEvent}
        tooltip={capitalize(t(`general.OPEN_SETTINGS`))}
      >
        <AdminNavIconWrapper
          $active={isActive(LeftActiveAdminPageEnum.Settings)}
        >
          <SVG_MUI.MenuSlidersSVG />
        </AdminNavIconWrapper>
      </LeftBarButton>
    </LeftBarNavigationStyled>
  );
};
